/* ══════════════════════════════════════════════════════════════════════════
   GOB — CART QUANTITY SELF-HEAL  (V162, 2026-10-20)

   THE BUG
   -------
   Shopify gives every cart line a key ("<variant id>:<hash>"). The hash changes
   when the cart's discounts change, e.g. TREAT20 being applied or re-applied.
   If the drawer was painted before that, its + / − buttons still carry the
   OLD key. /cart/change.js answers 400 "bad_request", theme.js then fails on
   the reply, swallows the error and leaves the row greyed out (is-loading):
   the drawer looks stuck.

   THE FIX
   -------
   1. A /cart/change(.js) POST by line key that comes back 400 is retried once
      with the line's current key (same variant, found in /cart.js). Only when
      exactly one line has that variant, so the wrong line is never changed.
   2. After every drawer paint, no quantity control stays locked.
   ══════════════════════════════════════════════════════════════════════════ */
(function () {
  var F = window.fetch;
  if (!F || F.__gobHeal) return;
  var RE = /\/cart\/change(\.js)?(\?|$)/;

  function healed(input, init) {
    var self = this, args = arguments;
    if (typeof input !== 'string' || !RE.test(input) || !init || typeof init.body !== 'string' ||
        String(init.method || 'GET').toUpperCase() !== 'POST') return F.apply(self, args);
    var body;
    try { body = JSON.parse(init.body); } catch (e) { return F.apply(self, args); }
    if (!body || typeof body.id !== 'string' || body.id.indexOf(':') < 0) return F.apply(self, args);

    return F.apply(self, args).then(function (r) {
      if (r.status !== 400) return r;
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      return F.call(window, root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (c) { return c.json(); })
        .then(function (cart) {
          var vid = body.id.split(':')[0];
          var hit = ((cart && cart.items) || []).filter(function (i) { return String(i.variant_id) === vid; });
          if (hit.length !== 1 || hit[0].key === body.id) return r;
          var next = {}, k;
          for (k in body) if (Object.prototype.hasOwnProperty.call(body, k)) next[k] = body[k];
          next.id = hit[0].key;
          var init2 = {};
          for (k in init) if (Object.prototype.hasOwnProperty.call(init, k)) init2[k] = init[k];
          init2.body = JSON.stringify(next);
          return F.call(self, input, init2);
        })
        .catch(function () { return r; });
    });
  }
  healed.__gobHeal = true;
  window.fetch = healed;

  function unlock() {
    var d = document.getElementById('HeaderCart');
    if (!d) return;
    [].forEach.call(d.querySelectorAll('.js-qty__wrapper.is-loading'), function (w) { w.classList.remove('is-loading'); });
  }
  document.addEventListener('gob:cart-painted', function () { setTimeout(unlock, 0); });
})();
